import { getNestedTranslation } from '@colonist/i18n';
import { ColonistOneTimePurchaseType, LobbyImage, ColonistMembershipType } from '@colonist/types';
import { StoreProductType, StripeCheckoutTypes } from './BaseColonistStoreProduct.ts';
export var MobileMembershipIAPSKUIds = /*#__PURE__*/ function(MobileMembershipIAPSKUIds) {
    MobileMembershipIAPSKUIds["EliteYearly"] = "elite_yearly";
    MobileMembershipIAPSKUIds["EliteMonthly"] = "elite_monthly";
    MobileMembershipIAPSKUIds["Holiday2023AllAccessPass"] = "all_access_pass_holiday_2023";
    MobileMembershipIAPSKUIds["PremiumYearly"] = "premium_yearly";
    MobileMembershipIAPSKUIds["PremiumMonthly"] = "premium_monthly";
    MobileMembershipIAPSKUIds["PlusYearly"] = "plus_yearly";
    MobileMembershipIAPSKUIds["PlusMonthly"] = "plus_monthly";
    return MobileMembershipIAPSKUIds;
}({});
export var MobileMembershipGiftIAPSKUIds = /*#__PURE__*/ function(MobileMembershipGiftIAPSKUIds) {
    MobileMembershipGiftIAPSKUIds["EliteYearly"] = "elite_yearly_gift";
    MobileMembershipGiftIAPSKUIds["EliteMonthly"] = "elite_monthly_gift";
    MobileMembershipGiftIAPSKUIds["PremiumYearly"] = "premium_yearly_gift";
    MobileMembershipGiftIAPSKUIds["PremiumMonthly"] = "premium_monthly_gift";
    MobileMembershipGiftIAPSKUIds["PlusYearly"] = "plus_yearly_gift";
    MobileMembershipGiftIAPSKUIds["PlusMonthly"] = "plus_monthly_gift";
    return MobileMembershipGiftIAPSKUIds;
}({});
export class ColonistMembershipPerk {
}
export class PerkAllMaps extends ColonistMembershipPerk {
    constructor(...args){
        super(...args), this.type = ColonistMembershipPerkType.AllMaps, this.description = {
            key: 'strings:storePage.sections.membership.perks.allMaps'
        }, this.imageUrl = LobbyImage.CheckMark;
    }
}
export class PerkAllExpansions extends ColonistMembershipPerk {
    constructor(...args){
        super(...args), this.type = ColonistMembershipPerkType.AllExpansions, this.description = {
            key: 'strings:storePage.sections.membership.perks.allExpansions'
        }, this.imageUrl = LobbyImage.CheckMark;
    }
}
export class PerkRankedGames extends ColonistMembershipPerk {
    constructor(...args){
        super(...args), this.type = ColonistMembershipPerkType.PremiumMatchmaking, this.description = {
            key: 'strings:storePage.sections.membership.perks.premiumMatchmaking.title'
        }, this.imageUrl = LobbyImage.CheckMark;
    }
}
export class PerkCustomLinks extends ColonistMembershipPerk {
    constructor(...args){
        super(...args), this.type = ColonistMembershipPerkType.CustomLinks, this.description = {
            key: 'strings:storePage.sections.membership.perks.customLinks'
        }, this.imageUrl = LobbyImage.CheckMark;
    }
}
export class PerkColonistCoins extends ColonistMembershipPerk {
    constructor(...args){
        super(...args), this.type = ColonistMembershipPerkType.ColonistCoins, this.description = {
            key: 'strings:storePage.sections.membership.perks.colonistCoinsPerMonth'
        }, this.imageUrl = LobbyImage.CheckMark;
    }
}
export class PerkNoAds extends ColonistMembershipPerk {
    constructor(...args){
        super(...args), this.type = ColonistMembershipPerkType.NoAds, this.description = {
            key: 'strings:storePage.sections.membership.perks.noAdsAndFullScreen'
        }, this.imageUrl = LobbyImage.CheckMark;
    }
}
export class PerkAllColors extends ColonistMembershipPerk {
    constructor(...args){
        super(...args), this.type = ColonistMembershipPerkType.AllColors, this.description = {
            key: 'strings:storePage.sections.membership.perks.allColors'
        }, this.imageUrl = LobbyImage.CheckMark;
    }
}
export class PerkBasicReplay extends ColonistMembershipPerk {
    constructor(...args){
        super(...args), this.type = ColonistMembershipPerkType.BasicReplay, this.description = {
            key: 'strings:storePage.sections.membership.perks.basicReplay'
        }, this.imageUrl = LobbyImage.CheckMark;
    }
}
export class PerkFullReplay extends ColonistMembershipPerk {
    constructor(...args){
        super(...args), this.type = ColonistMembershipPerkType.FullReplay, this.description = {
            key: 'strings:storePage.sections.membership.perks.fullReplay'
        }, this.imageUrl = LobbyImage.CheckMark;
    }
}
import { ColonistMembershipPerkType } from '@colonist/lobby-types';
export class ColonistMembershipProduct {
    // BaseColonistStoreProduct
    getProductName() {
        const membershipBody = {
            key: 'strings:storePage.membership.body'
        };
        const nestedTranslations = {
            title: this.membershipTitle,
            frequency: this.getFrequencyTranslation()
        };
        const membershipTranslation = getNestedTranslation(membershipBody, nestedTranslations);
        return membershipTranslation;
    }
    getFrequencyTranslation() {
        const frequencyKey = this.billedAnnually ? 'strings:storePage.membership.frequency.annual' : 'strings:storePage.membership.frequency.monthly';
        return {
            key: frequencyKey
        };
    }
    getDefaultPrice() {
        return `${this.price / 100}`;
    }
    getAnnualPrice() {
        return `${this.price * 12 / 100}`;
    }
    static getBaseAnnualPriceOfAnnualMembership(membershipType) {
        switch(membershipType){
            case ColonistMembershipType.PlusYearly:
                return ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PlusMonthly).getAnnualPrice();
            case ColonistMembershipType.PremiumYearly:
                return ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PremiumMonthly).getAnnualPrice();
            case ColonistMembershipType.EliteYearly:
                return ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.EliteMonthly).getAnnualPrice();
            default:
                return undefined;
        }
    }
    static getMonthlyPriceOfAnnualMembership(membershipType) {
        switch(membershipType){
            case ColonistMembershipType.PlusYearly:
                return ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PlusMonthly).getDefaultPrice();
            case ColonistMembershipType.PremiumYearly:
                return ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PremiumMonthly).getDefaultPrice();
            case ColonistMembershipType.EliteYearly:
                return ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.EliteMonthly).getDefaultPrice();
            default:
                return undefined;
        }
    }
    static getMonthlyProductOfAnnualMembership(membershipType) {
        switch(membershipType){
            case ColonistMembershipType.PlusYearly:
                return ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PlusMonthly);
            case ColonistMembershipType.PremiumYearly:
                return ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PremiumMonthly);
            case ColonistMembershipType.EliteYearly:
                return ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.EliteMonthly);
            default:
                return undefined;
        }
    }
    // BaseColonistStoreProduct
    static isAnnualMembership(membershipType) {
        switch(membershipType){
            case ColonistMembershipType.PlusYearly:
            case ColonistMembershipType.PremiumYearly:
            case ColonistMembershipType.EliteYearly:
                return true;
            default:
                return false;
        }
    }
    static getAllMembershipProducts() {
        return Array.from(this.products.values()).filter((product)=>product.oneTimePurchaseType == null);
    }
    // TODO: should override in ColonistGiftMembershipProduct to return ColonistOneTimePurchaseProduct
    static getMembershipProduct(membershipType) {
        return this.products.get(membershipType);
    }
    static initProducts(discordSKUIds) {
        const holidayProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.Holiday2023AllAccessPass,
            price: 699,
            discordSKUId: discordSKUIds.passAllAccessHoliday2023,
            mobileIAPSKUId: "all_access_pass_holiday_2023",
            membershipTitle: {
                key: 'strings:storePage.membership.title.holiday2023'
            },
            membershipColor: 'membership_type_holiday_2023',
            lobbyImage: LobbyImage.StoreMembershipHoliday2023,
            perks: [
                new PerkRankedGames(),
                new PerkNoAds(),
                new PerkAllExpansions(),
                new PerkAllMaps()
            ],
            billedAnnually: false,
            bestValue: false,
            discount: 0,
            isActive: ()=>false
        });
        holidayProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.Holiday2023AllAccessPass;
        this.products.set(ColonistMembershipType.Holiday2023AllAccessPass, holidayProduct);
        this.products.set(ColonistMembershipType.PlusMonthly, new ColonistMembershipProduct({
            type: ColonistMembershipType.PlusMonthly,
            price: 899,
            discordSKUId: discordSKUIds.membershipPlusMonthly,
            mobileIAPSKUId: "plus_monthly",
            membershipTitle: {
                key: 'strings:storePage.membership.title.plus'
            },
            membershipColor: 'membership_type1',
            lobbyImage: LobbyImage.StoreMembershipPlus,
            perks: [
                new PerkRankedGames(),
                new PerkNoAds(),
                new PerkBasicReplay()
            ],
            billedAnnually: false,
            bestValue: false,
            discount: 0,
            isActive: ()=>true
        }));
        this.products.set(ColonistMembershipType.PremiumMonthly, new ColonistMembershipProduct({
            type: ColonistMembershipType.PremiumMonthly,
            price: 1899,
            discordSKUId: discordSKUIds.membershipPremiumMonthly,
            mobileIAPSKUId: "premium_monthly",
            membershipTitle: {
                key: 'strings:storePage.membership.title.premium'
            },
            membershipColor: 'membership_type2',
            lobbyImage: LobbyImage.StoreMembershipPremium,
            perks: [
                new PerkRankedGames(),
                new PerkNoAds(),
                new PerkFullReplay(),
                new PerkAllExpansions(),
                new PerkAllMaps()
            ],
            billedAnnually: false,
            bestValue: true,
            discount: 0,
            isActive: ()=>true
        }));
        this.products.set(ColonistMembershipType.EliteMonthly, new ColonistMembershipProduct({
            type: ColonistMembershipType.EliteMonthly,
            price: 2499,
            discordSKUId: discordSKUIds.membershipEliteMonthly,
            mobileIAPSKUId: "elite_monthly",
            membershipTitle: {
                key: 'strings:storePage.membership.title.elite'
            },
            membershipColor: 'membership_type3',
            lobbyImage: LobbyImage.StoreMembershipElite,
            perks: [
                new PerkRankedGames(),
                new PerkNoAds(),
                new PerkFullReplay(),
                new PerkAllExpansions(),
                new PerkAllMaps(),
                new PerkAllColors()
            ],
            billedAnnually: false,
            bestValue: false,
            discount: 0,
            isActive: ()=>true
        }));
        this.products.set(ColonistMembershipType.PlusYearly, new ColonistMembershipProduct({
            type: ColonistMembershipType.PlusYearly,
            price: 699,
            discordSKUId: discordSKUIds.membershipPlusYearly,
            mobileIAPSKUId: "plus_yearly",
            membershipTitle: {
                key: 'strings:storePage.membership.title.plus'
            },
            membershipColor: 'membership_type1',
            lobbyImage: LobbyImage.StoreMembershipPlus,
            perks: [
                new PerkRankedGames(),
                new PerkNoAds(),
                new PerkBasicReplay()
            ],
            billedAnnually: true,
            bestValue: false,
            discount: 24,
            isActive: ()=>true
        }));
        this.products.set(ColonistMembershipType.PremiumYearly, new ColonistMembershipProduct({
            type: ColonistMembershipType.PremiumYearly,
            price: 1499,
            discordSKUId: discordSKUIds.membershipPremiumYearly,
            mobileIAPSKUId: "premium_yearly",
            membershipTitle: {
                key: 'strings:storePage.membership.title.premium'
            },
            membershipColor: 'membership_type2',
            lobbyImage: LobbyImage.StoreMembershipPremium,
            perks: [
                new PerkRankedGames(),
                new PerkNoAds(),
                new PerkFullReplay(),
                new PerkAllExpansions(),
                new PerkAllMaps()
            ],
            billedAnnually: true,
            bestValue: true,
            discount: 48,
            isActive: ()=>true
        }));
        this.products.set(ColonistMembershipType.EliteYearly, new ColonistMembershipProduct({
            type: ColonistMembershipType.EliteYearly,
            price: 1999,
            discordSKUId: discordSKUIds.membershipEliteYearly,
            mobileIAPSKUId: "elite_yearly",
            membershipTitle: {
                key: 'strings:storePage.membership.title.elite'
            },
            membershipColor: 'membership_type3',
            lobbyImage: LobbyImage.StoreMembershipElite,
            perks: [
                new PerkRankedGames(),
                new PerkNoAds(),
                new PerkFullReplay(),
                new PerkAllExpansions(),
                new PerkAllMaps(),
                new PerkAllColors()
            ],
            billedAnnually: true,
            bestValue: false,
            discount: 60,
            isActive: ()=>true
        }));
    }
    constructor(source){
        // BaseColonistStoreProduct
        this.storeProductType = StoreProductType.Membership;
        this.stripeCheckoutType = StripeCheckoutTypes.Subscription;
        this.itemQuantity = 1;
        this.oneTimePurchaseType = undefined;
        Object.assign(this, source);
    }
}
ColonistMembershipProduct.products = new Map();
